enum AuditStatus {
  // EDITABLE = 'EDITABLE',
  SUBMITTED = 'SUBMITTED',
  INSUBMISSION = 'INSUBMISSION',
  CREATED = 'CREATED',
  EDITED = 'EDITED',
  MIGRATED = 'MIGRATED',
  DRAFT = 'DRAFT',
  // DELETED = 'DELETED',
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const auditStatusLabels: Record<AuditStatus, string> = {
  // [AuditStatus.EDITABLE]: 'Edited',
  [AuditStatus.SUBMITTED]: 'Submitted',
  [AuditStatus.INSUBMISSION]: 'In Submission',
  [AuditStatus.EDITED]: 'Edited',
  [AuditStatus.CREATED]: 'Created',
  [AuditStatus.MIGRATED]: 'Migrated',
  [AuditStatus.DRAFT]: 'Draft',
  // [AuditStatus.DELETED]: 'Deleted',
};

export { AuditStatus, auditStatusLabels };
